<div class="flex flex-col xl:flex-row w-full p-5 gap-5">
    <div
        class="flex flex-col gap-5 w-full xl:w-3/4 xl:pr-5 xl:border-r xl:border-gray-border">
        <div>
            <rcp-oup-aging-claims-summary></rcp-oup-aging-claims-summary>
        </div>
        <div>
            <h4 class="mb-2 font-semibold">
                <span class="mr-2">Progress &amp; Trends</span>
                <span class="text-sm text-nowrap">
                    <i class="fa-solid fa-circle-info mr-1"></i>
                    <a
                        href="https://onespotbilling.zendesk.com/hc/en-us/articles/29758905105051-Aging-Summary-Progress-Trends"
                        target="_blank"
                        class="text-link">
                        Learn More</a
                    >
                </span>
            </h4>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <div class="grid grid-cols-1 gap-5">
                    <rcp-oup-claim-progress-metric
                        [claimStalledFilterId]="
                            STALLED_CLAIM_FILTER_IDS.AGING_CLAIMS_SUMMARY
                        "></rcp-oup-claim-progress-metric>
                </div>

                <rcp-oup-never-worked-age-metric
                    [claimStalledFilterId]="
                        STALLED_CLAIM_FILTER_IDS.AGING_CLAIMS_SUMMARY
                    "></rcp-oup-never-worked-age-metric>
            </div>
        </div>
    </div>
    <div class="w-full xl:w-1/4 flex flex-col gap-5">
        <div class="flex flex-col w-full gap-5">
            <rcp-oup-aging-worklist-summary></rcp-oup-aging-worklist-summary>
        </div>
        <div>
            <rcp-oup-aging-latest-upload-summary></rcp-oup-aging-latest-upload-summary>
        </div>
    </div>
</div>
